import { Icons } from '../icon'
import SystemLayout from './SystemLayout'
import { NavigationItemProps } from './NavigationMenu'
import Sidebar from './Sidebar'

const OrganizationLayout = ({
  knowledgeBaseId,
}: {
  knowledgeBaseId: string
}) => {
  const NAVIGATION_LINKS: NavigationItemProps[] = [
    {
      icon: Icons.Group,
      title: 'Base de conocimiento',
      description: 'Administra la base de conocimiento de tu empresa.',
      to: `/knowledge-bases/${knowledgeBaseId}`,
      end: true,
    },
    {
      icon: Icons.Upload,
      title: 'Sincronización',
      description: 'Configura la sincronización de tu base de conocimiento.',
      to: `/knowledge-bases/${knowledgeBaseId}/edit`,
    },
  ]
  return (
    <SystemLayout>
      <Sidebar
        title="Conocimiento"
        subtitle="Base de conocimiento de tu empresa"
        links={NAVIGATION_LINKS}
      />
    </SystemLayout>
  )
}

export default OrganizationLayout
